<template>
    <div class="p-emoji_picker__input_container">
        <input
            class="c-input_text p-emoji_picker__input"
            type="text"
            placeholder="Search"
            aria-owns="emoji-picker-list"
            aria-autocomplete="list"
            role="textbox"
            aria-label="Search for an emoji"
            aria-describedby="emoji-picker-search-description"
            data-qa="emoji_picker_input"
            @input="$emit('input', $event)"
        ><i
            class="c-icon p-emoji_picker__icon_search c-icon--search-medium"
            type="search-medium"
            aria-hidden="true"
        />
    </div>
</template>

<script>
export default {

}
</script>

<style>
.p-emoji_picker__input_container .p-emoji_picker__icon_search{
  top: 50%;
  transform: translateY(-50%);
  left: 20px;
  text-shadow: none;
  display: block;
  position: absolute;
}
</style>